import page0 from "./_0_employment-based-visa-information";
import page1 from "./_1_employer-point-of-contact-information";
import page2 from "./_2_employer-information";
import page3 from "./_3_agent_or_attorney_information";
import page4 from "./_4_wage-source-information";
import page5 from "./_5_job-offer-information";
import page6 from "./_6_minimum-job-requirements";
import page8 from "./_8_other-information";
import page9 from "./_9_place-of-employment-information";
import page10 from "./_10_additional-worksites";
import page11 from "./_11_application_documents";

const form_meta = {
  code: "Form ETA-9141",
  name: "PWD Prevailing Wage Determination",
};

const form_nav = [
  {
    name: "Employment Based Visa <br/>Information",
    prefix: "A",
  },
  {
    name: "Employer Point-of-Contact <br/>Information",
    prefix: "B",
  },
  {
    name: "Employer Information",
    prefix: "C",
  },
  {
    name: "Attorney or Agent Information <br/>(if applicable)",
    prefix: "D",
  },
  {
    name: "Wage Source Information",
    prefix: "E",
  },
  {
    name: "Job Description",
    prefix: "F.a",
  },
  {
    name: "Minimum Job Requirements and/or<br/> Alternative Job Requirements",
    prefix: "F.b/c",
  },
  {
    name: "Other Information",
    prefix: "F.d",
  },
  {
    name: "Place of Employment Information",
    prefix: "F.e",
  },
  {
    name: "Additional Worksites",
    prefix: "APX <br/>A",
    classes: "label-prefix-appx",
  },
  {
    name: "Application Documents",
    symbol: "upload",
  },
];

const uiSchema = [page0, page1, page2, page3, page4, page5, page6, page8, page9, page10, page11];

export { form_meta, form_nav };

export default uiSchema;
